import View from './View';

export default class Link extends View {

    /** @override */
    getTag() {

        return 'span';
    }

    getProps() {

        const props = super.getProps();
        if (typeof (this.props.link) == 'object')
            props['data-link'] = `{{ ui.${this.props.link.props.role} }}`;

        return props;
    }

}